import React, { memo } from 'react';

// styles
import {
  CouponTitle,
  CouponContainer,
  OfferTitle,
  OfferContainer,
  PlaceholderWrapper,
  PlaceholderContainer,
  PlaceholderSeparator,
} from './style';

interface IPlaceHolderProps {
  isDesktop?: boolean;
}

const PlaceHolder = ({ isDesktop = false }: IPlaceHolderProps) => {
  return (
    <>
      <PlaceholderWrapper data-test="offers-placeholder" parentOverflow={!isDesktop}>
        <PlaceholderContainer>
          <div>
            <CouponTitle />
            <CouponContainer />
          </div>
          <div>
            <OfferTitle />
            <OfferContainer />
          </div>
        </PlaceholderContainer>
      </PlaceholderWrapper>
      {!isDesktop && <PlaceholderSeparator />}
    </>
  );
};

export default memo(PlaceHolder);
